export function elementInViewport(el) {
	var top = el.offsetTop;
	var left = el.offsetLeft;
	var width = el.offsetWidth;
	var height = el.offsetHeight;

	while(el.offsetParent) {
		el = el.offsetParent;
		top += el.offsetTop;
		left += el.offsetLeft;
	}

	return (
		top >= window.pageYOffset &&
		left >= window.pageXOffset &&
		(top + height) <= (window.pageYOffset + window.innerHeight) &&
		(left + width) <= (window.pageXOffset + window.innerWidth)
	);
}

export function fadeOutNotifications(element, time = 3000) {
	if($(element).length) {
		setTimeout(function() {
			$(element).fadeOut();
		}, time);
	}
}

export function isValidEmailAddress(emailAddress) {
    var pattern = new RegExp(/^((([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+(\.([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+)*)|((\x22)((((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(([\x01-\x08\x0b\x0c\x0e-\x1f\x7f]|\x21|[\x23-\x5b]|[\x5d-\x7e]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(\\([\x01-\x09\x0b\x0c\x0d-\x7f]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))))*(((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(\x22)))@((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.?$/i);
    return pattern.test(emailAddress);
};

export function isValidPassword(password) {
    var passw = /^(?=.*\d)(?=.*[a-zA-Z]).{6,20}$/;
    if (!password.match(passw))
        return false;
    else
        return true;
};

export function calculatePoints(amount, ratio) {
    var points = amount / ratio;

    return points;
}

export function browserAlert(title, message) {
    $('#browser-alert-modal-js #browser-alert-title').html(title);
    $('#browser-alert-modal-js #browser-alert-message').html(message);
    $('#browser-alert-modal-js').modal('show');
}

export function arrayContainsAnotherArray(needle, haystack){
    for(var i = 0; i < needle.length; i++){
        if(haystack.indexOf(needle[i]) === -1)
            return false;
    }
    return true;
}

export function objectToUrlQuery(obj) {
    var str = [];
    for (var p in obj) {
        if (obj.hasOwnProperty(p)) {
            str.push(encodeURIComponent(p) + "=" + encodeURIComponent(obj[p]));
        }
    }

    return str.join("&");
}

export function getObjectFromURL(object = {}) {

    if (QueryString(null).c) {
        object.c = QueryString(null).c;
    }
    if (QueryString(null).s) {
        object.s = QueryString(null).s;
    }
    if (QueryString(null).sw) {
        object.sw = QueryString(null).sw;
    }
    if (QueryString(null).ne) {
        object.ne = QueryString(null).ne;
    }
    if (QueryString(null).z) {
        object.z = QueryString(null).z;
    }
    if (QueryString(null).mc) {
        object.mc = QueryString(null).mc;
    }
    if (QueryString(null).dms) {
        object.dms = QueryString(null).dms;
    }
    if (QueryString(null).vip) {
        object.vip = QueryString(null).vip;
    }
    if (QueryString(null).avd) {
        object.avd = QueryString(null).avd;
    }
    if (QueryString(null).avt) {
        object.avt = QueryString(null).avt;
    }
    if (QueryString(null).sb) {
        object.sb = QueryString(null).sb;
    }
    if (QueryString(null).st) {
        object.st = QueryString(null).st;
    }

    return  object;
}

export function selectFilterCheckbox(object, filterLabel, filterValue, selectedValues, filterClass, pageId, pageTitle) {
    var index = selectedValues.indexOf(filterValue);
    if (index == -1) {
        $(object).find('i').removeClass('fa-square').addClass('fa-check-square');
        selectedValues.push(filterValue);
    } else {
        $(object).find('i').removeClass('fa-check-square').addClass('fa-square');
        selectedValues.splice(index, 1);
    }

    if (selectedValues.length > 0) {
        updateURL(pageId, pageTitle, filterLabel, selectedValues.join(','));
    } else {
        var newURL = removeQueryStringParameter(filterLabel, window.location.href);
        history.replaceState({ id: pageId }, pageTitle, newURL);
    }
}

export function selectFilterRadio(object, filterLabel, filterValue, filterClass, pageId, pageTitle) {
    $('.'+filterClass+' i').removeClass('fa-check-circle').addClass('fa-circle');
    $(object).find('i').removeClass('fa-circle').addClass('fa-check-circle');

    updateURL(pageId, pageTitle, filterLabel, filterValue);
}

export function updateURL(id, title, parameter, value) {
    var url = updateQueryStringParameter(window.location.href, parameter, value);
    if (QueryString(window.location.search).param) {
        history.replaceState({ id: id }, title, url);
    } else {
        history.pushState({ id: id }, title, url);
    }
}

export function removeQueryStringParameter(key, sourceURL) {
    var rtn = sourceURL.split("?")[0],
        param,
        params_arr = [],
        queryString = (sourceURL.indexOf("?") !== -1) ? sourceURL.split("?")[1] : "";
    if (queryString !== "") {
        params_arr = queryString.split("&");
        for (var i = params_arr.length - 1; i >= 0; i -= 1) {
            param = params_arr[i].split("=")[0];
            if (param === key) {
                params_arr.splice(i, 1);
            }
        }
        rtn = rtn + "?" + params_arr.join("&");
    }
    return rtn;
}

export function updateQueryStringParameter(uri, key, value) {
    var re = new RegExp("([?&])" + key + "=.*?(&|$)", "i");
    var separator = uri.indexOf('?') !== -1 ? "&" : "?";
    if (uri.match(re)) {
        return uri.replace(re, '$1' + key + "=" + value + '$2');
    } else {
        return uri + separator + key + "=" + value;
    }
}

export function QueryString(url = null) {
    // This function is anonymous, is executed immediately and
    // the return value is assigned to QueryString!
	if (url == null) {
		url = window.location.search;
	}
    var query_string = {};
    var query = url.substring(1);
    var vars = query.split("&");
    for (var i = 0; i < vars.length; i++) {
        var pair = vars[i].split("=");
        // If first entry with this name
        if (typeof query_string[pair[0]] === "undefined") {
            query_string[pair[0]] = decodeURIComponent(pair[1]);
            // If second entry with this name
        } else if (typeof query_string[pair[0]] === "string") {
            var arr = [query_string[pair[0]], decodeURIComponent(pair[1])];
            query_string[pair[0]] = arr;
            // If third or later entry with this name
        } else {
            query_string[pair[0]].push(decodeURIComponent(pair[1]));
        }
    }
    return query_string;
};

export function equalCols(el) {
    var h = 0;
    $(el).each(function(){
        $(this).css({'height':'auto'});
        if($(this).outerHeight() > h)
        {
            h = $(this).outerHeight();
        }
    });
    $(el).each(function(){
        $(this).css({'min-height':h});
    });
}

export function formatMoney(amount, decimalCount = 2, decimal = ".", thousands = ",") {
	try {
		decimalCount = Math.abs(decimalCount);
		decimalCount = isNaN(decimalCount) ? 2 : decimalCount;

		const negativeSign = amount < 0 ? "-" : "";

		let i = parseInt(amount = Math.abs(Number(amount) || 0).toFixed(decimalCount)).toString();
		let j = (i.length > 3) ? i.length % 3 : 0;

		return negativeSign + (j ? i.substr(0, j) + thousands : '') + i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + thousands) + (decimalCount ? decimal + Math.abs(amount - i).toFixed(decimalCount).slice(2) : "");
	} catch (e) {
		console.log(e)
	}
};



// WEBPACK FOOTER //
// ./resources/assets/js/functions.js